import User from '@shared/types/user';
import { createContext, ReactNode, useContext } from 'react';

export interface IAuthService {
    getToken(): Promise<string>;
    getUser(): User;
    isAuthenticated(): boolean;
}

interface Props {
    children: ReactNode;
    authService: IAuthService;
}

interface AuthContext {
    authService: IAuthService;
}

const AuthContext = createContext<undefined | AuthContext>(undefined);

export default function AuthProvider({ children, authService }: Props) {
    if (!authService) {
        throw Error('Expected an auth service, but none was given.');
    }
    return <AuthContext.Provider value={{ authService }}>{children}</AuthContext.Provider>;
}

/**
 * Must be within Auth Context to use this hook
 */
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within a AuthProvider');
    }
    return context.authService;
};
